import type { NavigateFunction } from 'react-router'

export interface AuthResult {
  profile?: {
    needs_onboarding?: boolean
  }
  is_first_login?: boolean
  next_path?: string
}

/**
 * Server-validated next_path, but defend in depth client-side too -
 * relative path beginning with a single '/', no scheme, no protocol.
 */
export function isSafeNextPath(path: string | undefined | null): path is string {
  if (!path) return false
  if (!path.startsWith('/')) return false
  if (path.startsWith('//')) return false
  if (path.includes('://')) return false
  return true
}

/**
 * Routing rules after verify/dev-login:
 *  - Valid next_path (from a deep-link email) → navigate there directly,
 *    even on first-login. The deep-link is the consumer's stated intent;
 *    onboarding (optional password + name confirmation) can happen later
 *    from the profile page.
 *  - First-time sign-in OR needs onboarding without a next_path → /onboarding
 *  - Otherwise → wallet home
 */
export function routeAfterAuth(result: AuthResult, navigate: NavigateFunction) {
  const next = result.next_path
  if (isSafeNextPath(next)) {
    navigate(next, { replace: true })
    return
  }

  const needsOnboarding =
    result.is_first_login === true || result.profile?.needs_onboarding === true

  if (needsOnboarding) {
    navigate('/onboarding', { replace: true })
    return
  }

  navigate('/', { replace: true })
}
